import io from 'socket.io-client';
import { getUser, getLocalKey } from './commonfunction.js';

function getAuthToken() {
    try {
        const roles = ['super_admin', 'club_admin', 'player', 'parent', 'team_manager', 'non_affiliated_user'];
        for (const r of roles) {
            const user = getUser(r);
            if (user && user.token) return user.token;
            const direct = getLocalKey(r) || (typeof localStorage !== 'undefined' ? localStorage.getItem(r) : null);
            if (direct) {
                const parsed = typeof direct === 'string' ? JSON.parse(direct) : direct;
                if (parsed && parsed.token) return parsed.token;
            }
        }
    } catch (e) {}
    return '';
}

const CONNECTION_CONFIG = {
    forceNew: false,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    timeout: 10000,
    transports: ["websocket", "polling"],
    auth: (cb) => {
        cb({ token: getAuthToken() });
    }
};

export const SOCKET_CLIENT = io(process.env.REACT_APP_SOCKET_URL || '', CONNECTION_CONFIG);

export const sendNotification = (notificationData) => {
    SOCKET_CLIENT.emit('notificationSend', notificationData, (error) => {
        if (error) {
            // Suppress error in production
        }
    });
};